import base from "../../baseurl";
import token from "../../getTk";

const showAll = async (eventId) => {
  //console.log(eventId);
  const tokenA = token.get();
  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });
  const Create = await api
    .post("sport-galleries/showall/", {
      json: { eventId },
      timeout: false,
    })
    .json();
  return Create;
};

export default showAll;
